/// <amd-module name="Repos/SparseTree/AsyncSparseTreeLoadingCell" />
import { IAsyncSparseTreeLoadingCellProps } from "AsyncSparseTreeLoadingCell.Props";
import * as React from "react";
import { renderLoadingCell } from "VSSUI/Table";
import { ExpandableTreeCell } from "VSSUI/TreeEx";

export const AsyncSparseTreeLoadingCell: React.FunctionComponent<IAsyncSparseTreeLoadingCellProps> = props => {
    const { className, columnIndex, columnLayout, fetchData, treeItem } = props;

    React.useEffect(() => {
        fetchData && fetchData();
    }, []);

    return ExpandableTreeCell({ className, columnIndex, treeItem, children: renderLoadingCell(columnLayout) });
};
